import {useTranslation} from 'react-i18next'

// TODO: Dark mode
export const SingularityImage = () => {
  const {t} = useTranslation('about')

  return (
    <svg
      className="h-auto w-full max-w-7xl"
      viewBox="0 0 1071 650"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        fill="#231F20"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="27"
        fontWeight="500"
        letterSpacing="0em"
        textAnchor="middle"
        x="535.5"
        y="58.2609"
      >
        {t('singularity_image.title')}
      </text>
      <path
        d="M476.178 114.34C476.038 280.18 475.898 446.01 475.758 611.85"
        stroke="#C9CBCA"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path d="M993.729 525.141H94.1992" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M993.729 442.98H94.1992" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M993.729 360.82H94.1992" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M993.729 278.66H94.1992" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M993.729 196.5H94.1992" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M993.729 114.34H94.1992" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <g opacity="0.61">
        <path
          d="M833.099 423.691H118.109C111.479 423.691 106.109 418.321 106.109 411.691C106.109 405.061 111.479 399.691 118.109 399.691H833.099C839.729 399.691 845.099 405.061 845.099 411.691C845.099 418.321 839.729 423.691 833.099 423.691Z"
          fill="url(#paint0_linear_4935_20383)"
        />
      </g>
      <path d="M93.6992 611.85V84.8203" stroke="black" strokeMiterlimit="10" />
      <path d="M254.727 113.898V611.848" stroke="#C9CBCA" strokeMiterlimit="10" />
      <path d="M402.109 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M696.867 113.898V611.848" stroke="#C9CBCA" strokeMiterlimit="10" />
      <path
        d="M648.859 496.691C650.779 497.241 652.699 497.791 654.629 498.351"
        stroke="#6A61AB"
        strokeWidth="5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M666.781 501.84C729.591 519.87 792.391 537.91 855.201 555.94"
        stroke="#6A61AB"
        strokeWidth="5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeDasharray="12.65 12.65"
      />
      <path
        d="M861.281 557.68C863.201 558.23 865.121 558.78 867.051 559.34"
        stroke="#6A61AB"
        strokeWidth="5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M133.727 170.332C305.037 278.942 476.347 387.552 647.657 496.162"
        stroke="#6A61AB"
        strokeWidth="5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <text
        fill="#231F20"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="14"
        letterSpacing="0em"
      >
        <tspan x="210.758" y="632.491">
          {t('singularity_image.jan2024')}
        </tspan>
      </text>
      <text
        fill="#231F20"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="14"
        letterSpacing="0em"
      >
        <tspan x="653.906" y="632.491">
          {t('singularity_image.jan2025')}
        </tspan>
      </text>

      <path d="M438.949 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M365.258 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M512.648 604.852V611.392" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M549.488 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M475.758 602.18V611.85" stroke="black" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M291.566 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M328.418 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M623.18 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M586.34 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M660.027 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path
        opacity="0.4"
        d="M647.659 516.98C659.235 516.98 668.619 507.658 668.619 496.16C668.619 484.661 659.235 475.34 647.659 475.34C636.083 475.34 626.699 484.661 626.699 496.16C626.699 507.658 636.083 516.98 647.659 516.98Z"
        fill="#6A61AB"
        stroke="#6A61AB"
        strokeMiterlimit="10"
      />
      <path
        d="M647.656 502.66C651.246 502.66 654.156 499.75 654.156 496.16C654.156 492.57 651.246 489.66 647.656 489.66C644.066 489.66 641.156 492.57 641.156 496.16C641.156 499.75 644.066 502.66 647.656 502.66Z"
        fill="#6A61AB"
      />
      <path
        d="M133.728 173.339C133.488 173.339 133.248 173.309 133.018 173.239L92.9876 161.359C91.6676 160.969 90.9076 159.579 91.2976 158.249C91.6876 156.929 93.0776 156.169 94.4076 156.559L134.438 168.439C135.758 168.829 136.518 170.219 136.128 171.549C135.808 172.639 134.808 173.339 133.728 173.339Z"
        fill="url(#paint1_linear_4935_20383)"
      />
      <path
        d="M93.5977 566.231C95.0477 566.231 96.4977 566.221 97.9377 566.211"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M93.5977 484.071C95.0477 484.071 96.4977 484.061 97.9377 484.051"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M93.5977 401.911C95.0477 401.911 96.4977 401.901 97.9377 401.891"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M93.5977 319.75C95.0477 319.75 96.4977 319.74 97.9377 319.73"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M93.5977 237.59C95.0477 237.59 96.4977 237.58 97.9377 237.57"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M93.5977 155.43C95.0477 155.43 96.4977 155.42 97.9377 155.41"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <text
        fill="#19B99F"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="18"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="855.387" y="506.052">
          Language Singularity
        </tspan>
      </text>

      <path d="M842.109 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M878.949 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M805.258 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M915.797 602.18V611.85" stroke="black" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M731.566 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M768.418 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M220.109 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M183.258 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M109.566 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M146.418 604.852V611.862" stroke="#C9CBCA" strokeWidth="0.5" strokeMiterlimit="10" />
      <path
        d="M1023.24 611.352H93.1992V612.352H1023.24V611.352Z"
        fill="url(#paint2_linear_4935_20383)"
      />
      <path
        opacity="0.4"
        d="M864.327 579.089C875.903 579.089 885.287 569.768 885.287 558.269C885.287 546.771 875.903 537.449 864.327 537.449C852.751 537.449 843.367 546.771 843.367 558.269C843.367 569.768 852.751 579.089 864.327 579.089Z"
        fill="#6A61AB"
        stroke="#6A61AB"
        strokeMiterlimit="10"
      />
      <path
        d="M864.328 564.77C867.918 564.77 870.828 561.859 870.828 558.27C870.828 554.68 867.918 551.77 864.328 551.77C860.738 551.77 857.828 554.68 857.828 558.27C857.828 561.859 860.738 564.77 864.328 564.77Z"
        fill="#6A61AB"
      />
      <path
        opacity="0.4"
        d="M133.73 191.101C145.305 191.101 154.69 181.779 154.69 170.281C154.69 158.782 145.305 149.461 133.73 149.461C122.154 149.461 112.77 158.782 112.77 170.281C112.77 181.779 122.154 191.101 133.73 191.101Z"
        fill="#6A61AB"
        stroke="#6A61AB"
        strokeMiterlimit="10"
      />
      <path
        d="M133.727 176.781C137.316 176.781 140.227 173.871 140.227 170.281C140.227 166.691 137.316 163.781 133.727 163.781C130.137 163.781 127.227 166.691 127.227 170.281C127.227 173.871 130.137 176.781 133.727 176.781Z"
        fill="#6A61AB"
      />
      <text
        fill="black"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="17"
        fontWeight="500"
        letterSpacing="0em"
      >
        <tspan x="160.707" y="172.8">
          {t('singularity_image.typical_mts')}
        </tspan>
      </text>
      <text
        fill="#6A59A6"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="18"
        fontWeight="500"
        letterSpacing="0em"
      >
        <tspan x="891.328" y="561.919">
          Lara Grande
        </tspan>
      </text>

      <g opacity="0.61">
        <path
          d="M832.699 563.551H118.109C111.479 563.551 106.109 558.181 106.109 551.551C106.109 544.921 111.479 539.551 118.109 539.551H832.699C839.329 539.551 844.699 544.921 844.699 551.551C844.699 558.181 839.329 563.551 832.699 563.551Z"
          fill="url(#paint3_linear_4935_20383)"
        />
      </g>
      <path
        d="M832.188 551.501C849.638 545.071 841.367 513.641 865.427 513.641H1040.18"
        stroke="#1AB99E"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M833.837 558.749C829.747 559.469 825.847 556.739 825.127 552.649C824.407 548.559 827.137 544.659 831.227 543.939C835.317 543.219 839.217 545.949 839.937 550.039C840.657 554.129 837.927 558.029 833.837 558.749Z"
        fill="#1AB99E"
      />
      <text
        fill="#231F20"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="12"
        fontWeight="300"
        letterSpacing="0em"
      >
        <tspan x="64.8672" y="615.82">
          0
        </tspan>
      </text>
      <text
        fill="#231F20"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="12"
        fontWeight="300"
        letterSpacing="0em"
      >
        <tspan x="56.4062" y="122.359">
          12
        </tspan>
      </text>
      <text
        fill="#231F20"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="12"
        fontWeight="300"
        letterSpacing="0em"
      >
        <tspan x="67.8672" y="367.03">
          6
        </tspan>
      </text>
      <text
        fill="#231F20"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="12"
        fontWeight="300"
        letterSpacing="0em"
      >
        <tspan x="56.4062" y="204.21">
          10
        </tspan>
      </text>
      <text
        fill="#231F20"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="12"
        fontWeight="300"
        letterSpacing="0em"
      >
        <tspan x="67.8672" y="285.62">
          8
        </tspan>
      </text>
      <text
        fill="#231F20"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="12"
        fontWeight="300"
        letterSpacing="0em"
      >
        <tspan x="67.8672" y="449.03">
          4
        </tspan>
      </text>
      <text
        fill="#231F20"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="12"
        fontWeight="300"
        letterSpacing="0em"
      >
        <tspan x="67.8672" y="527.03">
          2
        </tspan>
      </text>
      <text
        fill="#6A59A6"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="18"
        fontWeight="500"
        letterSpacing="0em"
      >
        <tspan x="674.219" y="496.942">
          Lara
        </tspan>
      </text>
      <text
        fill="black"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="17"
        fontWeight="500"
        letterSpacing="0em"
      >
        <tspan x="212.68" y="417.972">
          {t('singularity_image.median_professional_translator')}
        </tspan>
      </text>
      <text
        fill="black"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="17"
        fontWeight="500"
        letterSpacing="0em"
      >
        <tspan x="212.68" y="556.741">
          {t('singularity_image.top_professional_translators')}
        </tspan>
      </text>
      <text
        transform="matrix(0 -1 1 0 17.5781 491.809)"
        fill="#231F20"
        style={{whiteSpace: 'pre'}}
        fontFamily="ARS Maquette Pro"
        fontSize="21"
        letterSpacing="0em"
      >
        <tspan x="0" y="20.9">
          {t('singularity_image.errors_per_1000_words')}
        </tspan>
      </text>

      <defs>
        <linearGradient
          id="paint0_linear_4935_20383"
          x1="106.109"
          y1="411.691"
          x2="845.099"
          y2="411.691"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEFEFD" stopOpacity="0" />
          <stop offset="0.04" stopColor="#FDE6D6" stopOpacity="0.19" />
          <stop offset="0.09" stopColor="#FBD2B2" stopOpacity="0.36" />
          <stop offset="0.13" stopColor="#F9BE91" stopOpacity="0.51" />
          <stop offset="0.19" stopColor="#F8AE75" stopOpacity="0.65" />
          <stop offset="0.25" stopColor="#F7A05D" stopOpacity="0.76" />
          <stop offset="0.31" stopColor="#F6954A" stopOpacity="0.85" />
          <stop offset="0.39" stopColor="#F58C3B" stopOpacity="0.92" />
          <stop offset="0.49" stopColor="#F58631" stopOpacity="0.96" />
          <stop offset="0.62" stopColor="#F5822B" stopOpacity="0.99" />
          <stop offset="1" stopColor="#F5822A" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4935_20383"
          x1="91.1976"
          y1="164.899"
          x2="136.228"
          y2="164.899"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.18" stopColor="#DBD8EA" stopOpacity="0.24" />
          <stop offset="0.46" stopColor="#AAA5CF" stopOpacity="0.57" />
          <stop offset="0.7" stopColor="#8780BB" stopOpacity="0.8" />
          <stop offset="0.89" stopColor="#7169AF" stopOpacity="0.95" />
          <stop offset="1" stopColor="#6A61AB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4935_20383"
          x1="93.1992"
          y1="611.852"
          x2="1023.23"
          y2="611.852"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#231F20" />
          <stop offset="0.54" stopColor="#231F20" />
          <stop offset="0.79" stopColor="#2E2B2C" stopOpacity="0.95" />
          <stop offset="0.89" stopColor="#5A5757" stopOpacity="0.75" />
          <stop offset="0.95" stopColor="#A4A3A3" stopOpacity="0.41" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4935_20383"
          x1="106.109"
          y1="551.561"
          x2="844.699"
          y2="551.561"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.04" stopColor="#FCF6D6" stopOpacity="0.17" />
          <stop offset="0.08" stopColor="#F9EDAD" stopOpacity="0.34" />
          <stop offset="0.13" stopColor="#F6E588" stopOpacity="0.5" />
          <stop offset="0.18" stopColor="#F4DF68" stopOpacity="0.64" />
          <stop offset="0.24" stopColor="#F2D94D" stopOpacity="0.75" />
          <stop offset="0.31" stopColor="#F1D437" stopOpacity="0.84" />
          <stop offset="0.39" stopColor="#F0D127" stopOpacity="0.91" />
          <stop offset="0.49" stopColor="#EFCE1B" stopOpacity="0.96" />
          <stop offset="0.62" stopColor="#EFCD14" stopOpacity="0.99" />
          <stop offset="1" stopColor="#EFCD13" />
        </linearGradient>
      </defs>
    </svg>
  )
}
